import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteAlarmOption = new Record({
  id: undefined,
  enabled: undefined,
  ignored: undefined,
  alert_users_on_alarm: undefined,
  alarm: undefined,
  site: undefined,
});

export const siteAlarmOptionSchema = new schema.Entity('siteAlarmOptions');

// for reading in nested models, object with { field: schema }
// siteAlarmOptionSchema.define({  });
